import React from 'react'
import { connect } from 'react-redux'
import MAYA from '../maya_api'
import { Redirect } from 'react-router-dom';
import Login from '../routes/Login/containers/LoginContainer'
import MainView from "../routes/Main/components/MainView";
import {loadProducts} from "../components/ShoppingCart/modules/shoppingCart";

export function asyncComponent(getComponent) {
  return class AsyncComponent extends React.Component {
    static Component = null;
    state = { Component: AsyncComponent.Component };

    componentWillMount() {
      if (!this.state.Component) {
        getComponent().then(Component => {
          AsyncComponent.Component = Component;
          this.setState({ Component })
        })
      }
    }
    render() {
      const { Component } = this.state;
      if (Component) {
        return <Component {...this.props} />
      }
      return null
    }
  }
}

export function privateComponent(Component) {
  class PrivateComponent extends React.Component {
    render(){
      const {is_authenticated} = this.props;

      if(MAYA.isAuthenticated() || is_authenticated) return <Component {...this.props} />;

      return <Login />
    }
  }

  const mapDispatchToProps = {};

  const mapStateToProps = (state) => ({
    is_authenticated: state.login.is_authenticated
  });

  return connect(mapStateToProps, mapDispatchToProps)(PrivateComponent)
}


// WEBPACK FOOTER //
// ./src/helpers/generateComponents.js